module.exports = "<label class=\"u-selfcheckbox2 clearfix btn btn-default btn-xs\" ng-class=\"{'z-crt': onoff,'z-disabled': cbDisable}\"><span class=text>{{text}} </span><i class=\"icon iconfont icon-duigou\"></i> <input ng-disabled=cbDisable type=checkbox id={{hash_id}} ng-model=onoff ng-change=checkboxChange() name={{name}}> </label>";


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox2/checkbox.html
// module id = hws8
// module chunks = 0